<template>
  <SplNuxtLink
    :to="link"
    :query="query"
    :is-external="isExternal"
    no-lang
    class="nuxt-link"
    @click="onClick"
  >
    <Card
      class="card-wrapper"
      animate-hover
      desktop-with-border
      mobile-with-border
    >
      <div
        class="item-card"
        :class="{
          'lateral-images': lateralImages,
          'lateral-images-mobile': lateralImagesMobile,
          'lateral-images-desktop': lateralImagesDesktop,
        }"
      >
        <div class="item-card__image">
          <GalleryMini
            v-if="images.length"
            :uuid="link.path"
            :images="images"
            class="item-card__image__gallery-mini"
          />
          <div class="item-card__image__tags">
            <slot name="item-tags" />
          </div>
          <div class="item-card__image__tags-bottom">
            <slot name="item-tags-bottom" />
          </div>
        </div>
        <div class="item-card__body">
          <slot name="body" />
        </div>
      </div>
    </Card>
  </SplNuxtLink>
</template>

<script lang="ts">
import Card from '@/core/components/shared/Card.vue'
import GalleryMini from './gallery/GalleryMini.vue'
import SplNuxtLink from './SplNuxtLink.vue'
import type { Picture } from '~/core/ts/entity/Picture'

export default defineNuxtComponent({
  components: {
    Card,
    GalleryMini,
    SplNuxtLink,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    images: {
      type: Array<Picture>,
      default: () => [],
    },
    lateralImages: {
      type: Boolean,
      default: () => false,
    },
    lateralImagesMobile: {
      type: Boolean,
      default: () => false,
    },
    lateralImagesDesktop: {
      type: Boolean,
      default: () => false,
    },
    isExternal: {
      type: Boolean,
      default: () => false,
    },
    imageLoading: {
      type: String,
      default: () => 'auto',
    },
  },
  setup(_, { emit }) {
    function onClick() {
      emit('click')
    }

    return {
      onClick,
    }
  },
})
</script>
<style lang="scss" scoped>
.card-wrapper {
  @apply h-full;
}
.nuxt-link:focus {
  @apply bg-white;
  @apply outline-none;
}

.item-card {
  // @apply flex-col;

  @screen lg {
    // @apply flex;
    // @apply flex-row;
  }

  &__image {
    @apply grid;
    @apply grid-cols-1 grid-rows-1;

    @apply p-1;
    min-height: 130px;

    @apply relative;
    &__tags {
      @apply absolute;

      top: 20px;
      right: 20px;
      @screen lg {
        top: 24px;
        right: 24px;
      }
    }

    &__tags-bottom {
      @apply absolute;

      bottom: 20px;
      // right: 20px;
      left: 0px;
      @apply w-full;
      @apply flex justify-around;

      @screen lg {
        bottom: 24px;
        // right: 24px;
      }
    }
  }

  &__body {
    @apply w-full;
    @apply p-2;
  }
}

.item-card.lateral-images {
  @apply grid;
  grid-template-columns: 15rem 1fr;
  grid-template-rows: 100%;

  @screen md {
    grid-template-columns: 20rem 1fr;
    grid-template-rows: 100%;
  }
  @screen lg {
    grid-template-columns: 30rem 1fr;
    grid-template-rows: 100%;
  }
}

.lateral-images {
  .item-card__body {
    @apply py-2;
  }
}

.item-card.lateral-images-mobile {
  @apply grid;
  grid-template-columns: 120px 1fr;
  grid-template-rows: 100%;
  @screen md {
    grid-template-columns: 20rem 1fr;
    grid-template-rows: 100%;
  }
  @screen lg {
    grid-template-columns: 100%;
    grid-template-rows: 200px 1fr;
  }
}

.item-card.lateral-images-desktop {
  @apply grid;
  grid-template-columns: 100%;
  grid-template-rows: 150px 1fr;
  @screen md {
    grid-template-columns: 20rem 1fr;
    grid-template-rows: 100%;
  }
  @screen lg {
    grid-template-columns: 30rem 1fr;
    grid-template-rows: 100%;
  }
  .item-card__body {
    @screen lg {
      @apply pl-4;
    }
  }
}

.item-card__image.lateral-images {
}

.legacy-margins {

}

</style>
